import { useState, useEffect, useRef } from "react";
import { IoCloudUploadOutline } from "react-icons/io5";


const FileUploader = ({ files, setFiles,type }) => {
  // console.log("The new type is:",type)
  const [videoUrl, setVideoUrl] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [error, setError] = useState("");
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (files && files.length > 0) {
      const file = files[0];
      const url = URL.createObjectURL(file);

      const video = document.createElement("video");
      video.preload = "metadata";
      video.src = url;

      video.onloadedmetadata = () => {
        // Duration is in seconds
        if (video.duration > 2 * 60 * 60) { // 2 hours
          setError("Video duration cannot exceed 2 hours.");
          setFiles(null);
          setVideoUrl(null);
        } else {
          setVideoUrl(url);
          setError("");
        }
      };

      return () => URL.revokeObjectURL(url);
    } else {
      setVideoUrl(null);
      setError("");
    }
  }, [files, setFiles]);

  const handleDragOver = (e) => { 
    e.preventDefault(); 
    setIsDragging(true);
  };
  
  const handleDragLeave = (e) => { 
    e.preventDefault(); 
    setIsDragging(false);
  };
  
  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      setFiles(e.dataTransfer.files);
    }
  };

  const handleChangeClick = () => {
    setFiles(null);
    setVideoUrl(null);
    setError("");
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleFileInputChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFiles(e.target.files);
    }
  };
const getType = (type) => {
  switch (type) {
    case 'Video':
      return 'video/*';
    case 'Audio':
      return 'audio/*'
    case 'PodCast':
      return 'video/*';
    default:
      return '*/*'; 
  }
};

  return (
 <div className="mb-4">
  {videoUrl ? (
    <div className="relative rounded-xl overflow-hidden bg-black h-[200px] w-full">
      <video
        controls
        src={videoUrl}
        className="w-full h-[200px] object-cover"
      />
      <div className="absolute top-3 right-3">
        <button
          onClick={handleChangeClick}
          className="px-4 py-2 bg-white/90 backdrop-blur-sm text-[#0f6abf] text-sm font-medium rounded-xl hover:bg-white hover:shadow-sm transition-all border border-white/20"
        >
          Change {type}
        </button>
      </div>
    </div>
  ) : (
    <label
      htmlFor="uploadFile"
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      className={`border-2 border-dashed rounded-2xl p-6 text-center cursor-pointer transition-all flex flex-col items-center justify-center gap-3 h-[200px] w-full
        ${isDragging
          ? "border-[#0f6abf] bg-[#e8f0f7]"
          : "border-gray-300 bg-gray-50 hover:border-[#0f6abf] hover:bg-[#e8f0f7]/20"
        }`}
    >
      <div className="w-16 h-16 bg-[#e8f0f7] rounded-full flex items-center justify-center">
        <svg className="w-8 h-8 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
        </svg>
      </div>

      <div>
        <p className="text-sm font-medium text-gray-900">
          Click or drag and drop your {type}
        </p>
        <span className="text-xs text-gray-500 mt-1 block">
          Max duration: 2 hours
        </span>
      </div>

      {error && (
        <div className="flex items-center gap-2 px-3 py-2 bg-red-50 text-red-600 rounded-lg">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span className="text-xs font-medium">{error}</span>
        </div>
      )}
    </label>
  )}

  <input
    type="file"
    id="uploadFile"
    ref={fileInputRef}
    onChange={handleFileInputChange}
    accept={getType(type)}
    hidden
  />
</div>

  );
};

export default FileUploader;
